import { deleteDoc, doc } from "firebase/firestore";
import { db } from "shared/api/firebase";
import { deleteContentBlocksModuleImages } from "./deleteContentBlocksModuleImages";

export const deleteModuleTemplate = async (moduleId: string) => {
  const moduleRef = doc(db, `moduleTemplates/${moduleId}`);

  await deleteContentBlocksModuleImages({ moduleRef });

  await deleteDoc(moduleRef);
};
